export default "__VITE_ASSET__CzMASniF__"